// Pure price statistics for the product detail page.
// Single source of truth for min / avg / max of in-stock competitors and my
// price position. Mirrors the existing ProductKpi.calculateKPI logic (stock >= 1).

// Latest in-stock price of a competitor, or undefined. A seller without a listed price
// (value 0 or none) is not one.
const lastInStockPrice = (competitor) => {
    if (!competitor || !competitor.prices || competitor.prices.length === 0) return undefined;
    const last = competitor.prices[competitor.prices.length - 1];
    return (last && last.stock && last.value > 0) ? last.value : undefined;
};

// myProduct: the is_mine competitor (or first one for market_search); competitors: the rest.
export const computePriceStats = (myProduct, competitors) => {
    const prices = (competitors || [])
        .map(lastInStockPrice)
        .filter(p => p !== undefined);

    const minPrice = prices.length === 0 ? undefined : Math.min(...prices);
    const maxPrice = prices.length === 0 ? undefined : Math.max(...prices);
    const avgPrice = prices.length === 0 ? undefined : prices.reduce((a, b) => a + b, 0) / prices.length;

    let myPrice;
    let currency;
    if (myProduct && myProduct.prices && myProduct.prices.length !== 0) {
        const last = myProduct.prices[myProduct.prices.length - 1];
        myPrice = last.value;
        currency = last.currency;
    } else if (competitors && competitors.length > 0 && competitors[0].prices?.length > 0) {
        currency = competitors[0].prices[competitors[0].prices.length - 1].currency;
    }

    // Stock of my listing (latest snapshot), or undefined.
    let myStock;
    if (myProduct && myProduct.prices && myProduct.prices.length !== 0)
        myStock = myProduct.prices[myProduct.prices.length - 1].stock;

    return {
        myPrice, minPrice, avgPrice, maxPrice, currency, myStock,
        inStockCount: prices.length,
    };
};

// 5-tier price position key from my price vs min/avg/max. Mirrors ProductKpi.byPriceText tiers.
// Returns one of: 'lowest' | 'cheaper' | 'equal' | 'expensive' | 'highest' | 'none'.
export const pricePositionKey = (stats) => {
    const { myPrice, minPrice, avgPrice, maxPrice } = stats;
    if (myPrice === undefined || minPrice === undefined) return 'none';
    if (myPrice <= minPrice) return 'lowest';
    if (avgPrice !== undefined && myPrice <= avgPrice) return 'cheaper';
    if (maxPrice !== undefined && myPrice >= maxPrice) return 'highest';
    if (avgPrice !== undefined && myPrice > avgPrice) return 'expensive';
    return 'equal';
};

// Map a position key to a pux chip color class suffix.
export const positionChipColor = (key) => ({
    lowest: 'green', cheaper: 'green', equal: 'gray', expensive: 'amber', highest: 'red', none: 'gray',
}[key] || 'gray');
